const AUTOMATIC = 1;
const MANUAL = 2;

export default {
  AUTOMATIC,
  MANUAL
};
